export default "__VITE_ASSET__CMsPlKyS__"